import { useMarketplace } from '@src/hooks/useMarketplace'

export const useFormatCurrency = (showDecimal = true) => {
  const marketplace = useMarketplace()
  const { currency } = marketplace.country

  const formatCurrency = (number: number, stringPrefix?: string): string => {
    const decimalPlaces = currency.decimalPlaces ?? 2
    const numberWithDecimals = number / 100

    try {
      const formatCurrencyValue = () =>
        new Intl.NumberFormat(marketplace.ietf || 'en-GB', {
          style: 'currency',
          currency: currency.iso4217,
          minimumFractionDigits: showDecimal ? decimalPlaces : 0,
          maximumFractionDigits: showDecimal ? decimalPlaces : 0,
        }).format(numberWithDecimals)

      return `${stringPrefix ?? ''}${formatCurrencyValue()}`
    } catch {
      // Fallback if currency formatting fails
      return `${stringPrefix ?? ''}${currency.iso4217} ${numberWithDecimals.toFixed(showDecimal ? decimalPlaces : 0)}`
    }
  }

  return formatCurrency
}
